import React from 'react';
import PropTypes from 'prop-types';

function CheckboxInput({
    checked,
    onChange,
    className,
    additionalClassName,
    children,
    isDisabled,
    ...props
}) {
    return (
        <div
            className={`form-check ${
                className ? className : 'form-check'
            } ${additionalClassName}`}
        >
            <input
                {...props}
                className="form-check-input"
                type="checkbox"
                disabled={isDisabled}
                checked={checked || false}
                onChange={e => onChange(e.target.checked)}
            />
            <label
                className="form-check-label"
                onClick={() => {
                    if (!isDisabled) onChange(!checked)
                }}
            >
                {children}
            </label>
        </div>
    );
}

CheckboxInput.propTypes = {
    checked: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
    additionalClassName: PropTypes.string
};

export default React.memo(CheckboxInput);
